module.exports = __webpack_public_path__ + "img/blog_menu_pic9.287ed5be.png";